/**
 * Utilidades para filtrado de fechas por mes y año
 */

/**
 * Genera array de años desde el año de inicio del proyecto hasta el actual + 1
 * Por defecto incluye desde 2020 para permitir consultar años anteriores
 */
export function generateYears(startYear: number = 2020): number[] {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  
  for (let year = startYear; year <= currentYear + 1; year++) {
    years.push(year);
  }
  
  return years.reverse(); // Años más recientes primero
}

/**
 * Verifica si una fecha coincide con el mes y año seleccionados
 * @param date - Fecha en formato string (ISO o cualquier formato válido)
 * @param selectedMonth - Mes seleccionado ('Todos', 'Enero', 'Febrero', etc.)
 * @param selectedYear - Año seleccionado
 * @returns true si coincide, false si no
 */
export function matchesMonthYear(
  date: string | undefined | null,
  selectedMonth: string,
  selectedYear: number
): boolean {
  // Si es "Todos", no filtramos por mes específico
  if (selectedMonth === 'Todos') return true;
  
  // Si no hay fecha, no coincide
  if (!date) return false;
  
  try {
    const dateObj = new Date(date);
    
    // Verificar que la fecha es válida
    if (isNaN(dateObj.getTime())) return false;
    
    const year = dateObj.getFullYear();
    const month = dateObj.toLocaleString('es-ES', { month: 'long' });
    
    // Comparar año y mes
    return year === selectedYear && month.toLowerCase() === selectedMonth.toLowerCase();
  } catch (error) {
    console.error('Error al procesar fecha:', error);
    return false;
  }
}

/**
 * Verifica si una fecha está dentro del rango de un año específico
 * Útil cuando selectedMonth es "Todos"
 */
export function matchesYear(
  date: string | undefined | null,
  selectedYear: number
): boolean {
  if (!date) return false;
  
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return false;
    
    return dateObj.getFullYear() === selectedYear;
  } catch (error) {
    return false;
  }
}


